var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_4545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5602 4.00197L12.8874 2.78921M2.50032 7.40975L1.23071 7.35213L2.50032 7.40975ZM7.80927 2.55871L7.86693 1.28833L7.80927 2.55871ZM3.94292 3.65622L2.73098 2.32821L3.94292 3.65622ZM2.26967 12.4913L3.59695 11.2786L2.26967 12.4913Z",
    stroke: "#0F6EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80831 5.97429C6.56931 5.87186 6.29202 5.92526 6.10815 6.10913C5.92428 6.29299 5.87088 6.57028 5.97331 6.80929L13.6043 24.615C13.7083 24.8576 13.9515 25.0108 14.2153 24.9998C14.4791 24.9889 14.7086 24.816 14.7921 24.5656L17.2352 17.2362L24.5646 14.7931C24.8151 14.7096 24.9879 14.48 24.9989 14.2162C25.0099 13.9524 24.8567 13.7093 24.614 13.6053L6.80831 5.97429Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_4545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteTraffic);
export default __webpack_public_path__ + "static/media/website-traffic.a63865838f1e063184699e731df132b4.svg";
export { ForwardRef as ReactComponent };